import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import MainMenu from "@/components/MainMenu";
import PongGame from "@/components/PongGame";
import HostSetup from "@/components/HostSetup";
import PongTournament from "@/components/PongTournament";
import Controller from "@/components/Controller";
import TavernHall from "@/components/TavernHall";
import ChatRoom from "@/components/ChatRoom";
import HostSmallTable from "@/components/HostSmallTable";
import JoinSmallTable from "@/components/JoinSmallTable";
// import CreditsPage from "@/components/CreditsPage";   // page removed per iter
import SoundGate from "@/components/SoundGate";
import ChessLanding from "@/components/Chess/ChessLanding";
import ChessHostPage from "@/components/Chess/ChessHostPage";
import ChessJoinPage from "@/components/Chess/ChessJoinPage";
import ChessRoom from "@/components/Chess/ChessRoom";
import PenteLanding from "@/components/Pente/PenteLanding";
import PenteHostPage from "@/components/Pente/PenteHostPage";
import PenteJoinPage from "@/components/Pente/PenteJoinPage";
import PenteRoom from "@/components/Pente/PenteRoom";
import CheckersLanding from "@/components/Checkers/CheckersLanding";
import CheckersHostPage from "@/components/Checkers/CheckersHostPage";
import CheckersJoinPage from "@/components/Checkers/CheckersJoinPage";
import CheckersRoom from "@/components/Checkers/CheckersRoom";
import KarnoffelLanding from "@/components/Karnoffel/KarnoffelLanding";
import KarnoffelHostPage from "@/components/Karnoffel/KarnoffelHostPage";
import KarnoffelJoinPage from "@/components/Karnoffel/KarnoffelJoinPage";
import KarnoffelRoom from "@/components/Karnoffel/KarnoffelRoom";
import KarnoffelTutorial from "@/components/Karnoffel/KarnoffelTutorial";
import KarnoffelMusicGate from "@/components/Karnoffel/KarnoffelMusicGate";
import ChantMusicGate from "@/components/ChantMusicGate";
import GlobalMuteButton from "@/components/GlobalMuteButton";
import GalleryPage from "@/components/Gallery/GalleryPage";
import FifteenHub from "@/components/Fifteen/FifteenHub";
import AngusPage from "@/components/AngusPage";
import MusicPortfolioPage from "@/components/MusicPortfolioPage";
import JokesPage from "@/components/JokesPage";
import CreditsPage from "@/components/CreditsPage";
import PeoplesChantPage from "@/components/PeoplesChantPage";
import LogPage from "@/components/LogPage";
import ProgressDiaryPage from "@/components/ProgressDiaryPage";
import ContactPage from "@/components/ContactPage";
import { startWupongBackground, stopWupongBackground, startTavernBackground, stopTavernBackground, startAngusMidi, stopAngusMidi } from "@/lib/sounds";

function ThemeBgmController() {
  const location = useLocation();
  useEffect(() => {
    const onWuPong = ["/pong-tournament", "/host", "/controller", "/game"].some(
      (p) => location.pathname === p || location.pathname.startsWith(p + "/")
    );
    const onTavern = location.pathname.startsWith("/tavern");
    const onAngus = location.pathname.startsWith("/games/angus");
    if (onWuPong) startWupongBackground();
    else stopWupongBackground();
    if (onTavern) startTavernBackground();
    else stopTavernBackground();
    if (onAngus) startAngusMidi();
    else stopAngusMidi();
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeBgmController />
        <KarnoffelMusicGate />
        <ChantMusicGate />
        <GlobalMuteButton />
        <Routes>
          <Route path="/" element={<MainMenu />} />

          <Route path="/pong-tournament" element={<SoundGate theme="wupong"><PongTournament /></SoundGate>} />
          <Route path="/host" element={<SoundGate theme="wupong"><HostSetup /></SoundGate>} />
          <Route path="/game" element={<SoundGate theme="wupong"><PongGame /></SoundGate>} />
          <Route path="/controller" element={<SoundGate theme="wupong"><Controller /></SoundGate>} />

          <Route path="/tavern" element={<SoundGate theme="tavern"><TavernHall /></SoundGate>} />
          <Route path="/tavern/big" element={<SoundGate theme="tavern"><ChatRoom mode="big" /></SoundGate>} />
          <Route path="/tavern/host" element={<SoundGate theme="tavern"><HostSmallTable /></SoundGate>} />
          <Route path="/tavern/join" element={<SoundGate theme="tavern"><JoinSmallTable /></SoundGate>} />
          <Route path="/tavern/room/:key" element={<SoundGate theme="tavern"><ChatRoom mode="small" /></SoundGate>} />

          <Route path="/games/chess"           element={<SoundGate theme="knock"><ChessLanding /></SoundGate>} />
          <Route path="/games/chess/host"      element={<SoundGate theme="knock"><ChessHostPage /></SoundGate>} />
          <Route path="/games/chess/join"      element={<SoundGate theme="knock"><ChessJoinPage /></SoundGate>} />
          <Route path="/games/chess/room/:key" element={<SoundGate theme="knock"><ChessRoom /></SoundGate>} />
          <Route path="/games/checkers"           element={<SoundGate theme="knock"><CheckersLanding /></SoundGate>} />
          <Route path="/games/checkers/host"      element={<SoundGate theme="knock"><CheckersHostPage /></SoundGate>} />
          <Route path="/games/checkers/join"      element={<SoundGate theme="knock"><CheckersJoinPage /></SoundGate>} />
          <Route path="/games/checkers/room/:key" element={<SoundGate theme="knock"><CheckersRoom /></SoundGate>} />
          <Route path="/games/karnoffel"           element={<SoundGate theme="knock"><KarnoffelLanding /></SoundGate>} />
          <Route path="/games/karnoffel/host"      element={<SoundGate theme="knock"><KarnoffelHostPage /></SoundGate>} />
          <Route path="/games/karnoffel/join"      element={<SoundGate theme="knock"><KarnoffelJoinPage /></SoundGate>} />
          <Route path="/games/karnoffel/tutorial"  element={<SoundGate theme="knock"><KarnoffelTutorial /></SoundGate>} />
          <Route path="/games/karnoffel/room/:key" element={<SoundGate theme="knock"><KarnoffelRoom /></SoundGate>} />
          <Route path="/games/pente"           element={<SoundGate theme="studio"><PenteLanding /></SoundGate>} />
          <Route path="/games/pente/host"      element={<SoundGate theme="studio"><PenteHostPage /></SoundGate>} />
          <Route path="/games/pente/join"      element={<SoundGate theme="studio"><PenteJoinPage /></SoundGate>} />
          <Route path="/games/pente/room/:key" element={<SoundGate theme="studio"><PenteRoom /></SoundGate>} />
          <Route path="/games/fifteen"   element={<SoundGate theme="fifteen"><FifteenHub /></SoundGate>} />
          <Route path="/games/angus"     element={<SoundGate theme="studio"><AngusPage /></SoundGate>} />
          <Route path="/gallery"         element={<SoundGate theme="studio"><GalleryPage /></SoundGate>} />
          <Route path="/playtesting-log" element={<SoundGate theme="studio"><LogPage kind="playtesting" /></SoundGate>} />
          <Route path="/gamedev-log"     element={<SoundGate theme="studio"><LogPage kind="gamedev" /></SoundGate>} />
          <Route path="/progress-diary"  element={<SoundGate theme="studio"><ProgressDiaryPage /></SoundGate>} />
          <Route path="/contact"         element={<SoundGate theme="studio"><ContactPage /></SoundGate>} />
          <Route path="/music-portfolio" element={<SoundGate theme="studio"><MusicPortfolioPage /></SoundGate>} />
          <Route path="/jokes"           element={<SoundGate theme="studio"><JokesPage /></SoundGate>} />
          <Route path="/credits"         element={<SoundGate theme="studio"><CreditsPage /></SoundGate>} />
          <Route path="/games/peoples-chant" element={<SoundGate theme="studio"><PeoplesChantPage /></SoundGate>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
